import { render, staticRenderFns } from "./TablePaginationNoItemPerPage.vue?vue&type=template&id=729c807c&"
import script from "./TablePaginationNoItemPerPage.vue?vue&type=script&lang=js&"
export * from "./TablePaginationNoItemPerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VPagination,VSpacer})
